import { useUpdateBonusStatus } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';
import { useModalContext } from 'src/hooks/useModalContext';

export const Buttons = () => {
  const { modalProps, closeModal } = useModalContext<{
    onCancel?: () => void;
    bonusId: number;
  }>();
  const { mutateAsync: updateBonusStatus, isPending } = useUpdateBonusStatus({
    onSuccess: closeModal
  });
  const { t } = useTranslation();

  const handleOkay = () => {
    updateBonusStatus({ bonus_id: modalProps?.bonusId, status: 'Activated' });
  };

  const handleCancel = () => {
    if (modalProps?.onCancel) {
      modalProps?.onCancel?.();
    } else {
      closeModal();
    }
  };

  return (
    <div className="w-full flex flex-col gap-2 px-4 412:px-7">
      <Button
        label={t('bonusModal.yesSure')}
        title={t('bonusModal.yesSure')}
        mode="button-secondary"
        onClick={handleOkay}
        loading={isPending}
        className="!max-w-full"
      />
      <Button
        label={t('general.cancel')}
        title={t('general.cancel')}
        className="!max-w-full"
        onClick={handleCancel}
      />
    </div>
  );
};
